import { useServiceStore } from "@mod/services";
import { ListSkeleton } from "@mod/core/ui/skeleton";
import { lazy, Suspense } from "react";

const ServiceAssignment = lazy(() =>
  import("./service-assignment/service-assignment").then((m) => ({ default: m.ServiceAssignment }))
);
const ServiceServers = lazy(() =>
  import("./service-servers/service-servers").then((m) => ({ default: m.ServiceServers }))
);
const ServicesDashboard = lazy(() =>
  import("./services-stats-dashboard").then((m) => ({ default: m.ServicesStatsDashboard }))
);
const MeetingAttendance = lazy(() =>
  import("./service-attendance/meeting-attendance").then((m) => ({ default: m.MeetingAttendance }))
);
const ServicesHistory = lazy(() =>
  import("./history-tab/services-history").then((m) => ({ default: m.ServicesHistory }))
);

const TabFallback = () => <ListSkeleton />;

export const ServicesMainTabContent = () => {
  const { viewSelected } = useServiceStore();

  const renderContent = () => {
    switch (viewSelected) {
      case "dashboard":
        return <ServicesDashboard />;
      case "assignedServices":
        return <ServiceAssignment />;
      case "servers":
        return <ServiceServers />;
      case "attendance":
        return <MeetingAttendance />;
      case "history":
        return <ServicesHistory />;
      default:
        return null;
    }
  };

  return <Suspense fallback={<TabFallback />}>{renderContent()}</Suspense>;
};
